<template>
  <div 
    class="no-data" 
    :style="{
      fontSize: css.fontSize,
      margin: css.margin,
      lineHeight: css.lineHeight,
      textAlign: css.textAlign
    }"
  >
    {{text}}
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default() {
        return  this.$t('txt.noData')
      }
    },
    css: {
      type: Object,
      default: () => {
        return {
          fontSize: '20px',
          margin: '10px 0',
          lineHeight: 'normal',
          textAlign: 'left'
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~assets/styles/varibles.styl'
.no-data
  font-weight: bold 
  color: #c1c1c1
  background: #ececec 
  border-radius: 5px 
  display: block 
  padding: 10px 
  text-shadow: 1px 1px 1px white 
</style>




// WEBPACK FOOTER //
// src/components/base/noDataTip/NoData.vue